import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = `${API_BASE_URL}/Purchase`;

/** 1. GET cost centers eligible for Supplier PO amendment (PCC / NPCC) */
export const getSupplierpoCCForAmend = (userId, roleId, ccType) =>
    axios.get(`${base}/GetSupplierpoCCForAmend`, {
        params: { Userid: userId, Roleid: roleId, CCType: ccType },
    });

/** 2. POST/GET all Supplier POs available for amendment under a cost center */
export const getAllSupplierPOForAmend = (ccCode, userId, roleId) =>
    axios.get(`${base}/GetAllSupplierPOForAmend`, {
        params: { CCCode: ccCode, Userid: userId, Roleid: roleId },
    });

/** 3. GET item grid (PO header + amendable item list) for a CC/PO combination */
export const getItemsForPOAmend = (ccCode, poNo) =>
    axios.get(`${base}/GetItemsForPOAmend`, {
        params: { CCCode: ccCode, PONO: poNo },
    });

/** 4. GET the upload-mandatory threshold value for a cost center */
export const getUploadDocSupplierAmendValue = (ccCode) =>
    axios.get(`${base}/UpdloadDocSupplieramendValue`, {
        params: { CCCode: ccCode },
    });

/** 5. GET already-uploaded PO / amendment documents for a PO number */
export const getPOUploadedDocs = (poNo, forType) =>
    axios.get(`${base}/POUploadedDocsView`, {
        params: { PONO: poNo, For: forType },
    });

/** 6. POST check whether budget is sufficient for the net increase amount */
export const checkBudgetForSuplrPOAmend = (payload) =>
    axios.post(`${base}/CheckBudgetForSuplrPOAmend`, payload);

/** 7. POST save (submit) the Supplier PO amendment */
export const saveSupplierPOAmend = (payload) =>
    axios.post(`${base}/SaveSupplierPOAmend`, payload);

/** 8. GET previous PO details for an item code (reference popup) */
export const getPreviousePODetails = (itemCode) =>
    axios.get(`${base}/GetPreviousePODetails`, {
        params: { Itemcode: itemCode },
    });

/** 9. POST upload the QCS PDF document to S3 (multipart/form-data) */
export const uploadSupplierPOAmendDoc = (file, fileName, folder, onProgress) => {
    const formData = new FormData();
    formData.append('file', file, fileName);
    formData.append('folder', folder);
    formData.append('fileName', fileName);
    return axios.post(`${API_BASE_URL}/AWSUpload/UploadFile`, formData, {
        // No Content-Type header here on purpose: setting one manually (even to
        // "multipart/form-data") strips the boundary the browser would otherwise
        // attach, which breaks server-side multipart parsing and makes every
        // upload fail regardless of file size. Let axios/the browser derive the
        // header (with boundary) from the FormData body.
        timeout: 5 * 60 * 1000, // large docs over a slow connection need real headroom
        onUploadProgress: onProgress
            ? (evt) => {
                if (!evt.total) return;
                onProgress(Math.round((evt.loaded / evt.total) * 100));
            }
            : undefined,
    });
};
